import { useEffect } from "react";
import { User } from "@supabase/supabase-js";
import { useNavigate } from "react-router-dom";

interface PinGateProps {
  user: User;
  onPinVerified: () => void;
  onUseOtherMethod: () => void;
}

export default function PinGate({ user, onPinVerified, onUseOtherMethod }: PinGateProps) {
  const navigate = useNavigate();

  useEffect(() => {
    // Store the user ID and callbacks for the EnterPin page to use
    sessionStorage.setItem('pending_pin_user_id', user.id);
    sessionStorage.setItem('pin_gate_active', 'true');
    
    // Navigate to the new iOS-style Enter PIN page
    navigate('/enter-pin');
  }, [user.id, navigate]);

  // Return null since we're immediately redirecting
  return null;
}
